import { PencilLine } from "lucide-react";

export const isPlaceholder = (v) =>
  typeof v === "string" && v.trim().startsWith("[INSERT");

export const Placeholder = ({ children, className = "" }) => (
  <span
    title="Editable placeholder — replace with verified information"
    className={`inline-flex items-center gap-1.5 rounded-md border border-dashed border-brand-amber bg-amber-50 px-2.5 py-1 text-[13px] font-medium text-amber-800 ${className}`}
  >
    <PencilLine className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
    {children}
  </span>
);
